/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { EntityRef } from './entityRef';
import type { PropertiesOutBuiltins } from './propertiesOutBuiltins';
import type { PropertyValueOut } from './propertyValueOut';

export interface PropertiesOut {
  builtins: PropertiesOutBuiltins;
  scorecard_definition: EntityRef | null;
  scorecard_type_source: string | null;
  scorecard_options: EntityRef[];
  custom: PropertyValueOut[];
}
